module.exports = __webpack_public_path__ + "static/media/image12.8983ebdb.png";